import {
    EditPencilIcon,
    GoogleDriveGraySVGIcon,
    ShareSVGIcon,
    TrashIcon,
} from '@/shared/assets'
import { CommandGroup, CommandItem } from '@/shared/ui'
import { DocumentRecordWithType } from '@synapex/shared2/gateway-rest-api'
import { Check, XIcon } from 'lucide-react'

const commandItemClassName =
    'flex cursor-pointer justify-between rounded p-[6px] text-xs font-normal hover:bg-synapex-blue-light'

type DeleteActionProps = {
    showConfirmation: boolean
    onConfirm: () => void
    onCancel: (event: React.MouseEvent) => void
    onRequestConfirmation: () => void
}

function DeleteAction({
    showConfirmation,
    onConfirm,
    onCancel,
    onRequestConfirmation,
}: DeleteActionProps) {
    return (
        <CommandItem
            className={commandItemClassName}
            onSelect={onRequestConfirmation}
        >
            <span>Удалить</span>
            {showConfirmation ? (
                <div className="flex justify-between">
                    <div onClick={onConfirm}>
                        <Check className="ml-2 cursor-pointer text-[#056FFF]" />
                    </div>
                    <div onClick={onCancel}>
                        <XIcon className="cursor-pointer" />
                    </div>
                </div>
            ) : (
                <img src={TrashIcon} />
            )}
        </CommandItem>
    )
}

type CustomContractActionsMenuProps = {
    onDelete: () => void
    onEdit: () => void
    showDeleteConfirmation: boolean
    onRequestDeleteConfirmation: () => void
    onCancelDelete: (event: React.MouseEvent) => void
    disabled: boolean
    contractName: string
}

export function CustomContractActionsMenu({
    onDelete,
    onEdit,
    showDeleteConfirmation,
    onRequestDeleteConfirmation,
    onCancelDelete,
    disabled,
    contractName,
}: CustomContractActionsMenuProps) {
    const disabledOptions = (
        <>
            <CommandItem>
                <span className="w-full break-words">{contractName}</span>
            </CommandItem>
        </>
    )

    const enabledOptions = (
        <>
            <DeleteAction
                showConfirmation={showDeleteConfirmation}
                onConfirm={onDelete}
                onCancel={onCancelDelete}
                onRequestConfirmation={onRequestDeleteConfirmation}
            />
            <CommandItem className={commandItemClassName} onSelect={onEdit}>
                <span>Редактировать</span>
                <EditPencilIcon className="h-4 w-4" />
            </CommandItem>
        </>
    )

    const Items = disabled ? disabledOptions : enabledOptions

    return <CommandGroup className="p-0">{Items}</CommandGroup>
}

type DefaultContractActionsMenuProps = {
    contract: DocumentRecordWithType
    disabled: boolean
    onSendToSelf: () => void
    onEdit: () => void
    onOpenGoogleDrive: () => void
    onDelete: () => void
    showDeleteConfirmation: boolean
    onRequestDeleteConfirmation: () => void
    onCancelDelete: (event: React.MouseEvent) => void
}

export function DefaultContractActionsMenu({
    disabled,
    onSendToSelf,
    onEdit,
    onOpenGoogleDrive,
    onDelete,
    showDeleteConfirmation,
    onRequestDeleteConfirmation,
    onCancelDelete,
}: DefaultContractActionsMenuProps) {
    return (
        <CommandGroup className="p-0">
            <CommandItem
                className={commandItemClassName}
                onSelect={onSendToSelf}
            >
                <span>Отправить себе в PDF</span>
                <ShareSVGIcon className="stroke-blue-primary" />
            </CommandItem>
            {!disabled && (
                <CommandItem className={commandItemClassName} onSelect={onEdit}>
                    <span>Редактировать</span>
                    <EditPencilIcon className="h-4 w-4" />
                </CommandItem>
            )}
            <CommandItem
                className={commandItemClassName}
                onSelect={onOpenGoogleDrive}
            >
                <span>Ссылка на документ</span>
                <GoogleDriveGraySVGIcon />
            </CommandItem>
            {!disabled && (
                <DeleteAction
                    showConfirmation={showDeleteConfirmation}
                    onConfirm={onDelete}
                    onCancel={onCancelDelete}
                    onRequestConfirmation={onRequestDeleteConfirmation}
                />
            )}
        </CommandGroup>
    )
}
